<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11" class="mx-auto my-6" align="center">
        <h2>Profils d'autres utilisateurs</h2>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-container>
      <v-row justify="center"
        ><v-col cols="12" md="8">
          <v-list dense>
            <v-list-item
              v-for="(profile, index) in profiles"
              :key="profile.userId"
              two-line
              :class="{ 'grey-background': index % 2 }"
            >
              <v-list-item-avatar
                ><img src="../assets/workout.png"
              /></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ profile.nickname }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ profile.firstName }} {{ profile.name }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-btn
                text
                :to="{ name: 'user', params: { nickname: profile.nickname } }"
                ><v-icon color="#151515">mdi-chevron-right</v-icon></v-btn
              >
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { db } from "@/services/firebaseServices.js";
export default {
  data() {
    return {
      profiles: []
    };
  },
  methods: {
    getUsersProfiles() {
      db.collection("users")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = doc.data();
            const userId = data.userId;
            const name = data.userData.name;
            const firstName = data.userData.firstName;
            const nickname = data.userData.nickname;

            const singleProfile = {
              userId: userId,
              name: name,
              firstName: firstName,
              nickname: nickname
            };
            this.profiles.push(singleProfile);
          });
        });
    }
  },
  created() {
    this.getUsersProfiles();
  }
};
</script>

<style>
.grey-background {
  background-color: rgb(240, 240, 240);
}
</style>